import React, { useState, useEffect } from 'react';
import './PopUpScreen.css';
import PopUpimage from '../../assets/Hruthi AI News LetterPop-up.png';
import { RxCross2 } from 'react-icons/rx';
import { baseUrl } from '../../config/baseurl';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StartupPopup = ({ onClose }) => {
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [name, setName] = useState('');
    const [isAgreed, setIsAgreed] = useState(false);

    const handleNameChange = (e) => {
        const value = e.target.value;
        if (/^[A-Za-z ]*$/.test(value)) {
            setName(value);
        }
    };

    const handleMobileChange = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        value = value.replace(/^0+/, '');
        value = value.replace(/^91/, '');
        setMobile(value.slice(0, 10));
    };

    useEffect(() => {
        if (mobile.startsWith('0') || mobile.startsWith('91') || mobile.startsWith('+91')) {
            let sanitizedMobile = mobile.replace(/^0+/, '').replace(/^91/, '').replace(/^\+91/, '');
            setMobile(sanitizedMobile);
        }
    }, [mobile]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isAgreed) {
            toast.error('You must agree to the Terms & Conditions and Privacy Policy.');
            return;
        }

        if (mobile.length !== 10) {
            toast.error('Phone number must be exactly 10 digits.');
            return;
        }

        try {
            const response = await fetch(`${baseUrl}/v1/user/subscription`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ name, gmail: email, phone: mobile }),
            });

            if (response.ok) {
                const data = await response.json();
                toast.success(data.message || 'Subscription successful!');
                setEmail('');
                setMobile('');
                setName('');

            } else {
                const errorData = await response.json();
                toast.error(errorData.message || 'Subscription failed. Please try again.');
            }
        } catch (err) {
            toast.error(err.message || 'An unexpected error occurred. Please try again later.');
        }
    };

    return (
        <div className="popup-modal-container">
            <div className="popup-modal-content">
                <img src={PopUpimage} alt="Pop-up visual" className="popup-left-section" />
                <div className="popup-right-section">
                    <button className="popup-close-btn" onClick={onClose} aria-label="Close">
                        <RxCross2 />
                    </button>
                    <h2 className="popup-title">Subscribe to our newsletter</h2>
                    <p className="popup-description">
                        Fill in your name, email, and mobile number below to join our newsletter today!
                    </p>
                    <form onSubmit={handleSubmit} className="popup-form">
                        <input
                            type="text"
                            placeholder="Enter your name"
                            value={name}
                            onChange={handleNameChange}
                            required
                            className="popup-input"
                        />
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="popup-input"
                        />
                        <input
                            type="tel"
                            placeholder="Enter your mobile number"
                            value={mobile}
                            onChange={handleMobileChange}
                            required
                            className="popup-input"
                            autoComplete="tel"
                        />
                        <div className="popup-checkbox-container">
                            <input
                                type="checkbox"
                                id="termsCheckbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                                className="popup-checkbox"
                            />
                            <label htmlFor="termsCheckbox" className="popup-checkbox-label">
                                I hereby agree to the <a href="#" target="_blank">T&C</a> & <a href="#" target="_blank">Privacy Policy</a> of Hruthiai Techub
                            </label>
                        </div>
                        <button type="submit" className="popup-submit-btn">
                            Download Placement Prep
                        </button>
                    </form>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
        </div>
    );
};

export default StartupPopup;
